/**
 * lucide-react ships no brand/logo icons — this is a generic rounded-square
 * camera glyph (not Meta's trademarked wordmark/logo) drawn in the same
 * stroke style as the rest of the icon set, used wherever we need a visual
 * stand-in for "Instagram" next to that channel's name.
 */
export default function InstagramIcon({
  size = 24,
  strokeWidth = 2,
  className,
}: {
  size?: number;
  strokeWidth?: number;
  className?: string;
}) {
  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 24 24"
      fill="none"
      stroke="currentColor"
      strokeWidth={strokeWidth}
      strokeLinecap="round"
      strokeLinejoin="round"
      className={className}
      aria-hidden
    >
      <rect x="3" y="3" width="18" height="18" rx="5" ry="5" />
      <circle cx="12" cy="12" r="4" />
      <circle cx="17.2" cy="6.8" r="0.6" fill="currentColor" stroke="none" />
    </svg>
  );
}
